import {Component} from '@angular/core';
@Component({
  selector: 'app-amdocs-loader',
  templateUrl: './amdocs-app-loader.component.html',
  styleUrls: ['./amdocs-app-loader.component.scss']
})
export class AmdocsAppLoaderComponent {
  public assetsPath:string="/assets/icons/";

  constructor() {
    // No dependencies to inject
  }
}
